import { render, staticRenderFns } from "./EmployeeMetrics.vue?vue&type=template&id=2a7cc74e&"
import script from "./EmployeeMetrics.vue?vue&type=script&lang=js&"
export * from "./EmployeeMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports